import type { Tab, LayoutType } from 'types';
import type { TemplateFormsState } from '../index';

interface Payload {
  layoutType: LayoutType;
  tab: Tab;
}

export const addTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, tab } = payload;
  if (state[layoutType].tabs.some((t) => t.id === tab.id)) return;
  state[layoutType].tabs.push(tab);
};
